import { render, staticRenderFns } from "./ProgressLms.vue?vue&type=template&id=766cd855&scoped=true&"
import script from "./ProgressLms.vue?vue&type=script&lang=js&"
export * from "./ProgressLms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766cd855",
  null
  
)

export default component.exports